var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "opciones-top",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_System_Menu",
    d: "M0,9.791V8.444H13.707V9.791ZM0,5.623V4.171H13.707V5.623ZM0,1.347V0H13.707V1.347Z",
    fill: "#1a1446"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "perfil"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons_System_Icons_Menu",
    "data-name": "Icons/System Icons/Menu",
    transform: "translate(9.44 11.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11",
    "data-name": "Grupo 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_System_Menu-2",
    "data-name": "Icon_System_Menu",
    d: "M0,9.791V8.444H13.707V9.791ZM0,5.623V4.171H13.707V5.623ZM0,1.347V0H13.707V1.347Z",
    fill: "#1a1446"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_47",
    "data-name": "Enmascarar grupo 47",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IconColor_Liberty_Blue_System",
    "data-name": "IconColor/Liberty Blue System",
    transform: "translate(-2.649 -2.35)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "IconColor_Liberty_Blue_System-2",
    "data-name": "IconColor/Liberty Blue System",
    width: 21.119,
    height: 20.702,
    fill: "#1a1446"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu);
export default __webpack_public_path__ + "static/media/hamburger-menu.1ab95eb48e3def2f1eeff27319f2a5de.svg";
export { ForwardRef as ReactComponent };